module.exports = __webpack_public_path__ + "static/media/smile.33211a17.svg";